import { errorHandler } from '@/utils/helpers'
import { webRequestClient } from '@/services'
import { get, isEmpty, flatten, cloneDeep } from 'lodash'
import { parseSegments, parseSharedTaxonomies, taxonomySegmentsRequestParamsConstructor, instanciateAll } from './helpers'

const actions = {
    /**
     * Get all shared taxonomies from API and save them in the store
     *
     * @param {Object} context - vuex context
     * @returns {Promise}
     */
    getSharedTaxonomies({ commit, dispatch, _rootGetters, rootState }) {
        commit('setIsLoading', true)

        const params = {
            account_id: rootState.account.accountId
        }
        return webRequestClient
            .get('/audience_admin/accounts_wam_custom_taxonomies/sharing/with_recency/json', { params })
            .then(res => {
                if (get(res, 'status', '') === 'KO' || isEmpty(res)) {
                    errorHandler('Error while retrieving shared taxonomies', commit)
                } else {
                    const taxonomies = parseSharedTaxonomies(get(res, 'list', []))
                    if (!isEmpty(taxonomies)) {
                        commit('setSharedTaxonomies', { taxonomies })
                        dispatch('launchMultipleHierarchiesRetrieve', {
                            list: res.list
                        })
                    }
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    },

    /**
     * Get taxonomy's segments from API and save them in the store
     *
     * @param {Object} context - vuex context
     * @param {Object} payload
     * @param {String|Number} payload.taxonomyId
     * @param {String} [source=custom] - To know if the taxonomy is custom or shared
     * @returns {Promise}
     */
    getTaxonomySegments({ commit }, { taxonomyId, source = 'custom', retention }) {
        commit('setIsLoading', true)
        return new Promise((resolve, reject) => {
            return webRequestClient
                .get(...taxonomySegmentsRequestParamsConstructor(taxonomyId))
                .then(res => {
                    if (get(res, 'status') === 'KO') {
                        reject('Error while retrieving taxonomy segments')
                        errorHandler('Error while retrieving taxonomy segments', commit)
                    } else {
                        const clone = cloneDeep(res.list)
                        clone?.map(c => (c.retention = retention))
                        resolve(clone)
                        const segments = parseSegments(taxonomyId, res.list, retention)
                        commit('setTaxonomySegments', { taxonomyId, source, segments })
                    }
                })
                .catch(err => {
                    reject('Error while retrieving shared segments')
                    errorHandler(err, commit)
                })
                .finally(() => {
                    commit('setIsLoading', false)
                })
        })
    },

    /**
     * Launches multiple request to retrieve hierarchies all at once
     * @param {Array} list Array of sharedTaxo which contains an id
     */
    launchMultipleHierarchiesRetrieve({ rootState, commit, dispatch }, { list }) {
        const taxonomies = Object.values(list)
        const requests = taxonomies.map(sharedTaxo => {
            return dispatch(
                'data/taxonomies/getTaxonomySegments',
                { taxonomyId: sharedTaxo.wam_custom_taxonomy_id, source: 'shared', retention: sharedTaxo.recency },
                { root: true }
            )
        })
        const frequencyOpts = rootState.data.settings.general.frequency

        Promise.all(requests).then(segments => {
            commit('setCollection', instanciateAll(taxonomies, flatten(segments), { frequencyOpts }))
        })
    }
}

export default actions
